import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyMobileBar from "./StickyMobileBar";
import ScrollIndicator from "./ScrollIndicator";
import { trackPageView } from "../lib/analytics";

const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Fire SPA page view to GA4 on every route change
    trackPageView(pathname);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ScrollIndicator />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <StickyMobileBar />
    </div>
  );
};

export default Layout;
